// Content unlock types for the credit deduction system

export type ContentType = 'post' | 'message' | 'media';

export interface UnlockRequest {
  contentId: string;
  contentType: ContentType;
  creditsRequired: number;
}

export interface UnlockSuccessResponse {
  success: true;
  alreadyUnlocked: boolean;
  creditsSpent: number;
  creditsRemaining: number;
  message: string;
  signedUrl?: string;
}

export interface UnlockErrorResponse {
  error: string;
  message: string;
  creditsRemaining?: number;
  creditsRequired?: number;
}

export type UnlockResponse = UnlockSuccessResponse | UnlockErrorResponse;

// Content pricing configuration
// Centralized pricing for all unlock-able content types
export const CONTENT_PRICING: Record<ContentType, number> = {
  post: 5,
  message: 1,
  media: 3,
};

// Helper to check if response is success
export function isUnlockSuccess(
  response: UnlockResponse
): response is UnlockSuccessResponse {
  return 'success' in response && response.success === true;
}
